<app-page-header-png [isCurveGray]="true" header={{language.calendarpagename}} backgroundPath="assets/images/lead/default.png">
</app-page-header-png>

<div class="container">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 bg">
            <div class='app-calendar' *ngIf="calendarVisible">
                <full-calendar #calendar [header]="{
                    left: 'title',
                    right: 'today prev,next ',
                    center: ''
                }" [plugins]="calendarPlugins" [weekends]="true" [events]="calendarEvents" (eventClick)="eventClick($event)">
                </full-calendar>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="Modal" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">
                        <img class="w-40 h-40 mr-2 icon-calendar" src="../../../assets/images/icon/ic-calendar.png">
                        <span class="mt-2"> {{ name }} </span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
                </div>
                <div class="modal-body">
                    <p> {{language.namefund}} </p>
                    <ul>
                        <li *ngFor="let item of FundName; let i = index">
                            {{item.fund}}
                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>